import React from 'react';
import { Route, Switch } from 'react-router-dom';
import LoginForm from 'App/Auth/LoginForm';
import PageNotFound from 'App/App/PageNotFound';

const Auth: React.FunctionComponent = () => (
  <Switch>
    <Route exact path="/login">
      <LoginForm onSuccess={() => window.location.assign('/')} />
    </Route>
    <Route path="*">
      <PageNotFound />
    </Route>
  </Switch>
);

export default Auth;
